export default __webpack_public_path__ + "static/media/interest-statements.14a91205.svg";